import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img
            src="/TCST_LeafIcon_Lowres.png.png"
            alt="The Canopy Stream Team"
          />
          <div>
            <h3 style={{fontSize: '0.875rem', fontWeight: '600', color: 'var(--forest-800)'}}>The Canopy Stream Team</h3>
            <p style={{fontSize: '0.75rem', color: 'var(--forest-600)'}}>Creativity • Community • Collaboration • Care</p>
          </div>
        </div>

        <div className="social-links">
          <a
            href="https://instagram.com/the_canopy_stream_team"
            target="_blank"
            rel="noopener noreferrer"
          >
            📷
          </a>
          <a
            href="https://twitter.com/The_Canopy_Team"
            target="_blank"
            rel="noopener noreferrer"
          >
            🐦
          </a>
          <a
            href="https://thecanopyteam.bsky.social"
            target="_blank"
            rel="noopener noreferrer"
          >
            🦋
          </a>
        </div>

        <div style={{fontSize: '0.75rem', color: 'var(--forest-500)'}}>
          © {new Date().getFullYear()} The Canopy Stream Team. All rights reserved.
        </div>
      </div>

      <div className="text-center" style={{marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid rgba(74, 157, 74, 0.2)'}}>
        <p style={{fontSize: '0.875rem', color: 'var(--forest-600)'}}>
          Built with 💚 for the streaming community
        </p>
      </div>
    </footer>
  );
};

export default Footer;